import React from 'react';
import { InfinityIcon, TruckIcon } from 'lucide-react';
import { PromoCountdown } from './PromoCountdown';
import { useActiveSale } from '../hooks/useActiveSale';
import { pricing } from '../data/promotion';
import { money } from './QuantityStepper';

/**
 * The single offer banner above the cover: sale name, price, the two
 * multi-pack perks and the weekly countdown. Links to the packs.
 */
export function AnnouncementBar() {
  const sale = useActiveSale();
  return <a href="#offer" className="block w-full bg-grit-500 text-ink-950 transition-colors duration-150 ease-grit hover:bg-grit-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ink-950" data-id="element-9" data-mp="5uc12bspn0c6">
      <div className="mx-auto flex max-w-[1400px] flex-col items-center gap-1.5 px-4 py-2 lg:flex-row lg:justify-between lg:gap-6 lg:px-8" data-id="element-10" data-mp="3s2kcka5vny6i">
        <p className="flex flex-wrap items-baseline justify-center gap-x-2.5 whitespace-nowrap" data-id="element-11" data-mp="1v761ho80c0i9">
          <span className="font-display text-lg font-extrabold uppercase leading-none tracking-wide sm:text-xl" data-id="element-12" data-mp="1q82w22o47s9r">
            <span aria-hidden="true" data-id="element-13" data-mp="6amj0stjpvpr">★ </span>
            {sale.name}
          </span>
          <span className="bg-ink-950 px-1.5 py-0.5 font-display text-base font-extrabold uppercase leading-none text-grit-500" data-id="element-14" data-mp="a7r28ww6lwc2">
            60% off
          </span>
          <span className="font-display text-base font-bold leading-none" data-id="element-15" data-mp="19yjtjv5y8kg">
            <span className="sr-only" data-id="element-16" data-mp="oy84ujkjysaj">Regular price </span>
            <span className="text-ink-950/55 line-through" data-id="element-17" data-mp="p0uhuyq7q005">{money(pricing.regular)}</span>{' '}
            {money(pricing.launch)}
          </span>
        </p>

        <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-0.5 text-[10px] font-extrabold uppercase tracking-[0.14em] sm:text-[11px]" data-id="element-18" data-mp="f7wuofa9zmv7">
          <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-19" data-mp="17xm0r71ued3o">
            <TruckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-20" data-mp="17vj07t32d1kp" />
            Free shipping on multi-packs
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-21" data-mp="1mkaustdbry2o">
            <InfinityIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-22" data-mp="1mi892lj7gr3r" />
            Lifetime guarantee on multi-packs
          </span>
        </p>

        <PromoCountdown compact className="whitespace-nowrap bg-ink-950 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-grit-500 sm:text-[11px]" data-id="element-23" data-mp="1clln1tf57u05" />
      </div>
    </a>;
}